import { CxEvent } from '@spartacus/core';

export class GtmGgCartAddEntrySuccessEvent extends CxEvent {
  event?: string;
  productId?: string;
  ecommerce?: {
    currencyCode?: string;
    add?: {
      products?: {
        name?: string;
        id?: string;
        price?: string | number;
        quantity?: string | number;
      }[];
    };
  };
}
